<div [classList]="scrolled ? 'main-menu background' : 'main-menu'">
  <div class="inner">
    <ng-container *ngIf="!scrolled">
      <div></div>
    </ng-container>
    <a [routerLink]="['/']">
      <img src="assets/images/DRC-Logo-white.svg" alt="dart rock cafe lohfelden" *ngIf="scrolled">
    </a>
    <button (click)="toggleMenu()">
      <picture>
        <source srcset="assets/images/menu.webp" type="image/webp">
        <img src="assets/images/menu.png" alt="Menü öffnen">
      </picture>
    </button>
  </div>
</div>

<div class="menu-fly-in" [classList]="show ? 'menu-fly-in active' : 'menu-fly-in'">
  <div class="inner-menu" itemscope itemtype="https://schema.org/SiteNavigationElement">
    <ul>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/'">
          Home<br>
          <span>Startseite & Überblick</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/']" fragment="oeffnungszeiten" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/#oeffnungszeiten'">
          Öffnungszeiten<br>
          <span>Wann wir für dich da sind</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/']" fragment="ueber-uns" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/#ueber-uns'">
          Über uns<br>
          <span>Wer wir sind</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/']" fragment="location" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/#location'">
          Location<br>
          <span>Einblicke in unsere Kneipe</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/']" fragment="events" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/#events'">
          Events<br>
          <span>Dartturniere & Specials</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/']" fragment="mannschaften" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/#mannschaften'">
          Mannschaften<br>
          <span>Unsere Dart Mannschaften</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/magazin']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/magazin'">
          Magazin<br>
          <span>News, Stories & Beiträge</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/rangliste-2026']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/rangliste-2026'">
          Rangliste<br>
          <span>Kasseler Steeldart Rangliste</span>
        </a>
      </li>
      <li itemprop="name">
        <a itemprop="url" [routerLink]="['/faq']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/faq'">
          FAQ<br>
          <span>Häufige Fragen &amp; Antworten</span>
        </a>
      </li>
    </ul>

    <div class="sub">
      <ul>
        <li itemprop="name">
          <a itemprop="url" [routerLink]="['/impressum']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/impressum'" rel="nofollow">
            Impressum
          </a>
        </li>
        <li itemprop="name">
          <a itemprop="url" [routerLink]="['/datenschutz']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [attr.href]="'/datenschutz'" rel="nofollow">
            Datenschutz
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

